export default __webpack_public_path__ + "static/media/logo.dc58432a.svg";